import { useEffect, useState } from "react";
import { addDays, format } from "date-fns";
import { es } from "date-fns/locale";
import { CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { WaTodas } from "@/components/WaTodas";
import { msgCitas } from "@/lib/avisoProf";

const siguienteDia = () => {
  const d = addDays(new Date(), 1);
  return d.getDay() === 0 ? addDays(d, 1) : d;
};

export const ResumenManana = () => {
  const ahora = new Date();
  const dia = siguienteDia();
  const f = format(dia, "yyyy-MM-dd");
  const clave = `resumen_manana_oculto_${format(ahora, "yyyy-MM-dd")}`;
  const [oculto, setOculto] = useState(() => localStorage.getItem(clave) === "1");
  const [data, setData] = useState(null);
  const tarde = ahora.getHours() >= 16 && ahora.getDay() !== 0;
  useEffect(() => {
    if (!tarde || oculto) return;
    Promise.all([api.get("/profesionales"), api.get("/appointments", { params: { desde: f, hasta: f } })])
      .then(([p, a]) => setData({ profs: p.data, appts: a.data.filter((x) => x.estado !== "anulada" && x.tipo !== "bloqueo") }));
  }, [tarde, oculto, f]);
  if (!tarde || oculto || !data) return null;
  const citas = (p) => data.appts.filter((a) => a.profesional_id === p.id).sort((x, y) => x.inicio.localeCompare(y.inicio));
  const n = data.profs.filter((p) => citas(p).length).length;
  if (!n) return null;
  const txt = format(dia, "EEEE d 'de' MMMM", { locale: es });
  return (
    <div className="mb-8 flex flex-wrap items-center gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-4 fade-up" data-testid="resumen-manana">
      <CalendarClock className="h-5 w-5 text-emerald-700" />
      <div className="flex-1 min-w-[220px]">
        <p className="text-sm font-semibold text-slate-800">Manda a cada profesional sus citas {dia.getDay() === 1 && ahora.getDay() === 6 ? "del lunes" : "de mañana"}</p>
        <p className="text-xs text-slate-600 first-letter:uppercase">{txt} · {n} profesional{n === 1 ? "" : "es"} con citas</p>
      </div>
      <WaTodas profs={data.profs} contar={(p) => citas(p).length} mensaje={(p) => msgCitas(p, citas(p), dia)} fechaTxt={txt} label="Preparar los WhatsApp" testId="resumen-manana-abrir" />
      <button type="button" onClick={() => { localStorage.setItem(clave, "1"); setOculto(true); }} data-testid="resumen-manana-ocultar" className="text-xs text-slate-500 underline">Ocultar por hoy</button>
    </div>
  );
};
